'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setScheduleContext = exports.setToken = exports.isLoggedIn = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _scheduleContext = require('constants/schedule-context');

var _scheduleContext2 = _interopRequireDefault(_scheduleContext);

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_TOKEN = 'classpass/user/SET_TOKEN';
var SET_SCHEDULE_CONTEXT = 'classpass/user/SET_SCHEDULE_CONTEXT';

var isLoggedIn = exports.isLoggedIn = function isLoggedIn(state) {
  return (0, _deep.deepExtract)('user.loggedIn', state, false);
};
var setToken = exports.setToken = function setToken(token, request) {
  return { type: SET_TOKEN, data: token, request: request };
};
var setScheduleContext = exports.setScheduleContext = function setScheduleContext(context) {
  return { type: SET_SCHEDULE_CONTEXT, data: context };
};

var initialState = {
  loggedIn: false,
  token: null,
  viewingNextCycle: false,
  scheduleContext: _scheduleContext2.default.CURRENT_CYCLE
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_TOKEN:
      if (action.request) {
        action.request.session.authToken = action.data;
      }
      return (0, _extends3.default)({}, state, {
        loggedIn: !!action.data,
        token: action.data
      });
    case SET_SCHEDULE_CONTEXT:
      return (0, _extends3.default)({}, state, {
        viewingNextCycle: action.data === _scheduleContext2.default.NEXT_CYCLE,
        scheduleContext: action.data
      });
    default:
      return state;
  }
}